webpackJsonp([1],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Forecast__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchCity__ = __webpack_require__(353);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Forecast: __WEBPACK_IMPORTED_MODULE_0__components_Forecast__["a" /* default */],
    SearchCity: __WEBPACK_IMPORTED_MODULE_1__components_SearchCity__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        _this.$store.commit('updateLoadingState', true);
        _this.$store.commit('saveLongitude', longitude);
        _this.$store.commit('saveLatitude', latitude);
        _this.$store.dispatch('getForecastsFromAPIByLatAndLon');
      });
      this.$store.commit('loadCitiesFromLocalStorage');
    }
  },

  computed: {
    getBackgroundColor: function getBackgroundColor() {
      var averageTemperature = this.$store.getters.getAverageTemperature;

      switch (true) {
        default:
          return 'background-color: cornflowerblue';
        case averageTemperature >= 30:
          return 'background-color: #ff4500';
        case averageTemperature >= 20 && averageTemperature < 30:
          return 'background-color: #ffd700';
        case averageTemperature >= 10 && averageTemperature < 20:
          return 'background-color: #9acd32';
        case averageTemperature >= 0 && averageTemperature < 10:
          return 'background-color: #836fff';
        case averageTemperature < 0:
          return 'background-color: #63b8ff';
      }
    },
    isLoading: function isLoading() {
      return this.$store.getters.getLoadingState && this.$store.getters.getSearchQuery && this.$store.getters.getSelectedCountry;
    }
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Forecast',
  computed: {
    getForecasts: function getForecasts() {
      return this.$store.getters.getForecasts;
    },
    getErrorMessage: function getErrorMessage() {
      return this.$store.getters.getErrorMessage;
    },
    getAnimationState: function getAnimationState() {
      return this.$store.getters.getAnimationState;
    }
  },
  methods: {
    getWeatherIcon: function getWeatherIcon(code) {
      var rainWithLightningCodes = [200, 201, 202, 230, 231, 232, 233];
      var rainCodes = [300, 301, 302, 500, 501, 502, 511, 520, 521, 522, 900];
      var snowCodes = [600, 601, 602, 610, 621, 611, 612, 623];
      var fogCodes = [700, 711, 721, 731, 741, 751];
      var clearSkyCodes = [800];
      var cloudsWithSunCodes = [801, 802, 803];
      var cloudsCodes = [804];

      switch (true) {
        default:
          return '\n            <div class="icon icon--cloud anim--expand">Clouds</div>\n          ';
        case rainWithLightningCodes.indexOf(code) !== -1:
          return '\n          <div class="icon icon--cloud icon--cloud-dark anim--flash">Storm cloud</div>\n          <div class="icon icon--rain icon--rain-1 anim--fall-1">Rain</div>\n          <div class="icon icon--rain icon--rain-2 anim--fall-2">Rain</div>\n          <div class="icon icon--rain icon--rain-3 anim--fall-3">Rain</div>\n          ';
        case rainCodes.indexOf(code) !== -1:
          return '\n          <div class="icon icon--cloud icon--cloud-dark">Rain cloud</div>\n          <div class="icon icon--rain icon--rain-1 anim--fall-1">Rain</div>\n          <div class="icon icon--rain icon--rain-2 anim--fall-2">Rain</div>\n          <div class="icon icon--rain icon--rain-3 anim--fall-3">Rain</div>\n          ';
        case snowCodes.indexOf(code) !== -1:
          return '\n           <div class="icon icon--cloud">Clouds</div>\n           <span class="icon icon--snow icon--snow-1 anim--float-down-1">Snow</span>\n           <span class="icon icon--snow icon--snow-2 anim--float-down-2">Snow</span>\n           <span class="icon icon--snow icon--snow-3 anim--float-down-3">Snow</span>\n          ';
        case fogCodes.indexOf(code) !== -1:
          return '\n            <span class="icon icon--fog icon--fog-1 anim--float-1">Fog</span>\n            <span class="icon icon--fog icon--fog-2 anim--float-2">Fog</span>\n            <span class="icon icon--fog icon--fog-3 anim--float-1">Fog</span>\n            <span class="icon icon--fog icon--fog-4 anim--float-2">Fog</span>\n          ';
        case clearSkyCodes.indexOf(code) !== -1:
          return '\n          <span class="icon icon--sun">Sun</span>\n          <span class="icon icon--sun-flare anim--pulse">Sun flare</span>\n          ';
        case cloudsWithSunCodes.indexOf(code) !== -1:
          return '\n          <span class="icon icon--sun icon--sun-small">Sun</span>\n          <span class="icon icon--sun-flare icon--sun-flare-small anim--pulse">Sun flare</span>\n          <div class="icon icon--cloud icon--cloud-sun anim--bobble">Cloudy with sun</div>\n          ';
        case cloudsCodes.indexOf(code) !== -1:
          return '\n            <div class="icon icon--cloud anim--expand">Clouds</div>\n          ';
      }
    },
    saveFavorite: function saveFavorite(city, code) {
      var favoriteList = this.$store.getters.getFavoriteCities;
      // eslint-disable-next-line max-len
      var index = favoriteList.findIndex(function (arr) {
        return arr.city.toLowerCase() === city.toLowerCase() && arr.code === code;
      });
      if (index !== -1) {
        this.$store.commit('updateAnimationState', false);
        this.$store.commit('deleteFromFavoriteList', index);
      } else {
        this.$store.commit('updateAnimationState', true);
        this.$store.commit('addToFavoriteList', {
          city: this.$store.getters.getSearchQuery,
          code: this.$store.getters.getSelectedCountry
        });
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('updateAnimationState', false);
    var city = this.$store.getters.getForecasts.city_name;
    var code = this.$store.getters.getForecasts.country_code;
    var favoriteList = this.$store.getters.getFavoriteCities;
    if (favoriteList.length !== 0 && city && code) {
      for (var i = 0; i < favoriteList.length; i += 1) {
        // eslint-disable-next-line max-len
        if (favoriteList[i].city.toLowerCase() === city.toLowerCase() && favoriteList[i].code === code) {
          this.$store.commit('updateAnimationState', true);
        }
      }
    }
  },

  filters: {
    getDate: function getDate(datetime) {
      var options = { weekday: 'long', month: 'long', day: 'numeric' };
      return new Date(datetime).toLocaleDateString('en-US', options);
    },
    toTextualDescription: function toTextualDescription(degrees) {
      if (degrees > 337.5) return 'Northerly';
      if (degrees > 292.5) return 'North Westerly';
      if (degrees > 247.5) return 'Westerly';
      if (degrees > 202.5) return 'South Westerly';
      if (degrees > 157.5) return 'Southerly';
      if (degrees > 122.5) return 'South Easterly';
      if (degrees > 67.5) return 'Easterly';
      if (degrees > 22.5) {
        return 'North Easterly';
      }
      return 'Northerly';
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    this.debouncedGetAnswer = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.getForecastsFromAPI, 600);
  },

  methods: {
    getForecastsFromAPI: function getForecastsFromAPI() {
      this.$store.dispatch('getForecastsFromAPI');
    },
    searchCityFromFavorite: function searchCityFromFavorite(city, code) {
      this.$store.commit('saveSearchQuery', city);
      this.$store.commit('saveSelectedCountry', code);
      this.$store.dispatch('getForecastsFromAPI');
    },
    removeFromFavoriteList: function removeFromFavoriteList(city, code) {
      var favoriteList = this.$store.getters.getFavoriteCities;
      for (var i = 0; i < favoriteList.length; i += 1) {
        if (favoriteList[i].city === city && favoriteList[i].code === code) {
          this.$store.commit('deleteFromFavoriteList', i);
          this.$store.commit('updateAnimationState', false);
        }
      }
    }
  },
  computed: {
    selectedCountry: {
      get: function get() {
        return this.$store.getters.getSelectedCountry;
      },
      set: function set(value) {
        this.$store.commit('updateAnimationState', false);
        this.$store.commit('saveSelectedCountry', value);
      }
    },
    searchQuery: {
      get: function get() {
        return this.$store.getters.getSearchQuery;
      },
      set: function set(value) {
        this.$store.commit('saveSearchQuery', value);
      }
    },
    getFavoriteCities: function getFavoriteCities() {
      return this.$store.getters.getFavoriteCities;
    }
  },
  watch: {
    selectedCountry: function selectedCountry() {
      if (this.searchQuery) {
        this.$store.dispatch('getForecastsFromAPI');
      }
    }
  }
});

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(142);
module.exports = __webpack_require__(344);


/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(366);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94005376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(365);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(92)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94005376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forecast_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8da1e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forecast_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(92)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forecast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8da1e90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forecast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 351:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getErrorMessage)?_c('h1',{staticClass:"error"},[_vm._v(_vm._s(_vm.getErrorMessage))]):(_vm.getForecasts.length !== 0)?_c('section',{staticClass:"forecast"},[_c('div',{staticClass:"forecast__current"},[_c('p',{staticClass:"forecast__location"},[_c('span',{staticClass:"forecast__city"},[_vm._v(_vm._s(_vm.getForecasts.city_name)+",")]),_vm._v(" "),_c('span',{staticClass:"forecast__country"},[_vm._v(_vm._s(_vm.getForecasts.country_code))]),_vm._v(" "),_c('button',{staticClass:"forecast__favorite heart click-heart",class:{'animated-heart': _vm.getAnimationState},attrs:{"aria-label":"Add to favorite"},on:{"click":function($event){_vm.saveFavorite(_vm.getForecasts.city_name, _vm.getForecasts.country_code)}}},[_vm._v("\n        Add to favorite\n      ")])])]),_vm._v(" "),_c('ul',{staticClass:"forecast__list"},_vm._l((_vm.getForecasts.data),function(forecast,index){return _c('li',{key:index,staticClass:"forecast__item"},[_c('span',{staticClass:"forecast__day"},[_vm._v(_vm._s(_vm._f("getDate")(forecast.datetime)))]),_vm._v(" "),_c('div',{staticClass:"weather",domProps:{"innerHTML":_vm._s(_vm.getWeatherIcon(forecast.weather.code))}}),_vm._v(" "),_c('p',{staticClass:"forecast__group forecast__group--mb"},[_c('span',{staticClass:"forecast__number"},[_vm._v(_vm._s(forecast.weather.description))])]),_vm._v(" "),_c('p',{staticClass:"forecast__group"},[_c('span',{staticClass:"forecast__number"},[_vm._v("Avg.temp: "+_vm._s(Math.ceil(forecast.temp)))]),_vm._v(" "),_c('span',{staticClass:"forecast__scale"},[_vm._v("°C")])]),_vm._v(" "),_c('p',{staticClass:"forecast__group"},[_c('span',{staticClass:"forecast__number"},[_vm._v("Pressure: "+_vm._s(Math.ceil(forecast.pres)))]),_vm._v(" "),_c('span',{staticClass:"forecast__scale"},[_vm._v("mb")])]),_vm._v(" "),_c('p',{staticClass:"forecast__group"},[_c('span',{staticClass:"forecast__number"},[_vm._v("Wind speed: "+_vm._s(Math.ceil(forecast.wind_spd)))]),_vm._v(" "),_c('span',{staticClass:"forecast__scale"},[_vm._v("m/s")])]),_vm._v(" "),_c('p',{staticClass:"forecast__group"},[_c('span',{staticClass:"forecast__number"},[_vm._v("Wind direction: "+_vm._s(_vm._f("toTextualDescription")(Math.ceil(forecast.wind_dir))))])]),_vm._v(" "),_c('p',{staticClass:"forecast__group"},[_c('span',{staticClass:"forecast__number"},[_vm._v("Humidity: "+_vm._s(Math.ceil(forecast.rh)))]),_vm._v(" "),_c('span',{staticClass:"forecast__scale"},[_vm._v("%")])])])}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCity_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410acd3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCity_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(92)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchCity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410acd3a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchCity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"search"},[(_vm.getFavoriteCities.length !== 0)?_c('div',{staticClass:"search__favorites"},[_c('h2',{staticClass:"search__title"},[_vm._v("Favorite countries")]),_vm._v(" "),_c('ul',{staticClass:"search__list"},_vm._l((_vm.getFavoriteCities),function(country){return _c('li',{staticClass:"search__item"},[_c('p',{staticClass:"search__desc",attrs:{"aria-label":"Favorite city"},on:{"click":function($event){_vm.searchCityFromFavorite(country.city, country.code)}}},[_c('span',{staticClass:"search__name"},[_vm._v(_vm._s(country.city)+",")]),_vm._v(" "),_c('span',{staticClass:"search__code"},[_vm._v(_vm._s(country.code))])]),_vm._v(" "),_c('button',{staticClass:"search__button",attrs:{"title":"Delete city","aria-label":"Delete from favorite"},on:{"click":function($event){_vm.removeFromFavoriteList(country.city, country.code)}}})])}))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search__country"},[_c('div',{staticClass:"search__wrapper"},[(!_vm.selectedCountry)?_c('h1',{staticClass:"search__title"},[_vm._v("Please, choose country before search")]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCountry),expression:"selectedCountry"}],staticClass:"search__select",attrs:{"aria-label":"Select country"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCountry=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"RU"}},[_vm._v("Russia")]),_vm._v(" "),_c('option',{attrs:{"value":"US"}},[_vm._v("USA")]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),(_vm.selectedCountry)?_c('div',{staticClass:"search__inner"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"search__input",attrs:{"type":"text","autofocus":"","placeholder":"Please, enter city name","aria-label":"City name"},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.debouncedGetAnswer]}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optgroup',{attrs:{"label":"Other countries"}},[_c('option',{attrs:{"value":"DZ"}},[_vm._v("Algeria")]),_vm._v(" "),_c('option',{attrs:{"value":"AD"}},[_vm._v("Andorra")]),_vm._v(" "),_c('option',{attrs:{"value":"AO"}},[_vm._v("Angola")]),_vm._v(" "),_c('option',{attrs:{"value":"AI"}},[_vm._v("Anguilla")]),_vm._v(" "),_c('option',{attrs:{"value":"AG"}},[_vm._v("Antigua & Barbuda")]),_vm._v(" "),_c('option',{attrs:{"value":"AR"}},[_vm._v("Argentina")]),_vm._v(" "),_c('option',{attrs:{"value":"AM"}},[_vm._v("Armenia")]),_vm._v(" "),_c('option',{attrs:{"value":"AW"}},[_vm._v("Aruba")]),_vm._v(" "),_c('option',{attrs:{"value":"AU"}},[_vm._v("Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"AT"}},[_vm._v("Austria")]),_vm._v(" "),_c('option',{attrs:{"value":"AZ"}},[_vm._v("Azerbaijan")]),_vm._v(" "),_c('option',{attrs:{"value":"BS"}},[_vm._v("Bahamas")]),_vm._v(" "),_c('option',{attrs:{"value":"BH"}},[_vm._v("Bahrain")]),_vm._v(" "),_c('option',{attrs:{"value":"BD"}},[_vm._v("Bangladesh")]),_vm._v(" "),_c('option',{attrs:{"value":"BB"}},[_vm._v("Barbados")]),_vm._v(" "),_c('option',{attrs:{"value":"BY"}},[_vm._v("Belarus")]),_vm._v(" "),_c('option',{attrs:{"value":"BE"}},[_vm._v("Belgium")]),_vm._v(" "),_c('option',{attrs:{"value":"BZ"}},[_vm._v("Belize")]),_vm._v(" "),_c('option',{attrs:{"value":"BJ"}},[_vm._v("Benin")]),_vm._v(" "),_c('option',{attrs:{"value":"BM"}},[_vm._v("Bermuda")]),_vm._v(" "),_c('option',{attrs:{"value":"BT"}},[_vm._v("Bhutan")]),_vm._v(" "),_c('option',{attrs:{"value":"BO"}},[_vm._v("Bolivia")]),_vm._v(" "),_c('option',{attrs:{"value":"BA"}},[_vm._v("Bosnia Herzegovina")]),_vm._v(" "),_c('option',{attrs:{"value":"BW"}},[_vm._v("Botswana")]),_vm._v(" "),_c('option',{attrs:{"value":"BR"}},[_vm._v("Brazil")]),_vm._v(" "),_c('option',{attrs:{"value":"BN"}},[_vm._v("Brunei")]),_vm._v(" "),_c('option',{attrs:{"value":"BG"}},[_vm._v("Bulgaria")]),_vm._v(" "),_c('option',{attrs:{"value":"BF"}},[_vm._v("Burkina Faso")]),_vm._v(" "),_c('option',{attrs:{"value":"BI"}},[_vm._v("Burundi")]),_vm._v(" "),_c('option',{attrs:{"value":"KH"}},[_vm._v("Cambodia")]),_vm._v(" "),_c('option',{attrs:{"value":"CM"}},[_vm._v("Cameroon")]),_vm._v(" "),_c('option',{attrs:{"value":"CA"}},[_vm._v("Canada")]),_vm._v(" "),_c('option',{attrs:{"value":"CV"}},[_vm._v("Cape Verde Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"KY"}},[_vm._v("Cayman Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"CF"}},[_vm._v("Central African Republic")]),_vm._v(" "),_c('option',{attrs:{"value":"CL"}},[_vm._v("Chile")]),_vm._v(" "),_c('option',{attrs:{"value":"CN"}},[_vm._v("China")]),_vm._v(" "),_c('option',{attrs:{"value":"CO"}},[_vm._v("Colombia")]),_vm._v(" "),_c('option',{attrs:{"value":"KM"}},[_vm._v("Comoros")]),_vm._v(" "),_c('option',{attrs:{"value":"CG"}},[_vm._v("Congo")]),_vm._v(" "),_c('option',{attrs:{"value":"CK"}},[_vm._v("Cook Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"CR"}},[_vm._v("Costa Rica")]),_vm._v(" "),_c('option',{attrs:{"value":"HR"}},[_vm._v("Croatia")]),_vm._v(" "),_c('option',{attrs:{"value":"CU"}},[_vm._v("Cuba")]),_vm._v(" "),_c('option',{attrs:{"value":"CY"}},[_vm._v("Cyprus North")]),_vm._v(" "),_c('option',{attrs:{"value":"CY"}},[_vm._v("Cyprus South")]),_vm._v(" "),_c('option',{attrs:{"value":"CZ"}},[_vm._v("Czech Republic")]),_vm._v(" "),_c('option',{attrs:{"value":"DK"}},[_vm._v("Denmark")]),_vm._v(" "),_c('option',{attrs:{"value":"DJ"}},[_vm._v("Djibouti")]),_vm._v(" "),_c('option',{attrs:{"value":"DM"}},[_vm._v("Dominica")]),_vm._v(" "),_c('option',{attrs:{"value":"DO"}},[_vm._v("Dominican Republic")]),_vm._v(" "),_c('option',{attrs:{"value":"EC"}},[_vm._v("Ecuador")]),_vm._v(" "),_c('option',{attrs:{"value":"EG"}},[_vm._v("Egypt")]),_vm._v(" "),_c('option',{attrs:{"value":"SV"}},[_vm._v("El Salvador")]),_vm._v(" "),_c('option',{attrs:{"value":"GQ"}},[_vm._v("Equatorial Guinea")]),_vm._v(" "),_c('option',{attrs:{"value":"ER"}},[_vm._v("Eritrea")]),_vm._v(" "),_c('option',{attrs:{"value":"EE"}},[_vm._v("Estonia")]),_vm._v(" "),_c('option',{attrs:{"value":"ET"}},[_vm._v("Ethiopia")]),_vm._v(" "),_c('option',{attrs:{"value":"FK"}},[_vm._v("Falkland Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"FO"}},[_vm._v("Faroe Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"FJ"}},[_vm._v("Fiji")]),_vm._v(" "),_c('option',{attrs:{"value":"FI"}},[_vm._v("Finland")]),_vm._v(" "),_c('option',{attrs:{"value":"FR"}},[_vm._v("France")]),_vm._v(" "),_c('option',{attrs:{"value":"GF"}},[_vm._v("French Guiana")]),_vm._v(" "),_c('option',{attrs:{"value":"PF"}},[_vm._v("French Polynesia")]),_vm._v(" "),_c('option',{attrs:{"value":"GA"}},[_vm._v("Gabon")]),_vm._v(" "),_c('option',{attrs:{"value":"GM"}},[_vm._v("Gambia")]),_vm._v(" "),_c('option',{attrs:{"value":"GE"}},[_vm._v("Georgia")]),_vm._v(" "),_c('option',{attrs:{"value":"DE"}},[_vm._v("Germany")]),_vm._v(" "),_c('option',{attrs:{"value":"GH"}},[_vm._v("Ghana")]),_vm._v(" "),_c('option',{attrs:{"value":"GI"}},[_vm._v("Gibraltar")]),_vm._v(" "),_c('option',{attrs:{"value":"GR"}},[_vm._v("Greece")]),_vm._v(" "),_c('option',{attrs:{"value":"GL"}},[_vm._v("Greenland")]),_vm._v(" "),_c('option',{attrs:{"value":"GD"}},[_vm._v("Grenada")]),_vm._v(" "),_c('option',{attrs:{"value":"GP"}},[_vm._v("Guadeloupe")]),_vm._v(" "),_c('option',{attrs:{"value":"GU"}},[_vm._v("Guam")]),_vm._v(" "),_c('option',{attrs:{"value":"GT"}},[_vm._v("Guatemala")]),_vm._v(" "),_c('option',{attrs:{"value":"GN"}},[_vm._v("Guinea")]),_vm._v(" "),_c('option',{attrs:{"value":"GW"}},[_vm._v("Guinea - Bissau")]),_vm._v(" "),_c('option',{attrs:{"value":"GY"}},[_vm._v("Guyana")]),_vm._v(" "),_c('option',{attrs:{"value":"HT"}},[_vm._v("Haiti")]),_vm._v(" "),_c('option',{attrs:{"value":"HN"}},[_vm._v("Honduras")]),_vm._v(" "),_c('option',{attrs:{"value":"HK"}},[_vm._v("Hong Kong")]),_vm._v(" "),_c('option',{attrs:{"value":"HU"}},[_vm._v("Hungary")]),_vm._v(" "),_c('option',{attrs:{"value":"IS"}},[_vm._v("Iceland")]),_vm._v(" "),_c('option',{attrs:{"value":"IN"}},[_vm._v("India")]),_vm._v(" "),_c('option',{attrs:{"value":"ID"}},[_vm._v("Indonesia")]),_vm._v(" "),_c('option',{attrs:{"value":"IR"}},[_vm._v("Iran")]),_vm._v(" "),_c('option',{attrs:{"value":"IQ"}},[_vm._v("Iraq")]),_vm._v(" "),_c('option',{attrs:{"value":"IE"}},[_vm._v("Ireland")]),_vm._v(" "),_c('option',{attrs:{"value":"IL"}},[_vm._v("Israel")]),_vm._v(" "),_c('option',{attrs:{"value":"IT"}},[_vm._v("Italy")]),_vm._v(" "),_c('option',{attrs:{"value":"JM"}},[_vm._v("Jamaica")]),_vm._v(" "),_c('option',{attrs:{"value":"JP"}},[_vm._v("Japan")]),_vm._v(" "),_c('option',{attrs:{"value":"JO"}},[_vm._v("Jordan")]),_vm._v(" "),_c('option',{attrs:{"value":"KZ"}},[_vm._v("Kazakhstan")]),_vm._v(" "),_c('option',{attrs:{"value":"KE"}},[_vm._v("Kenya")]),_vm._v(" "),_c('option',{attrs:{"value":"KI"}},[_vm._v("Kiribati")]),_vm._v(" "),_c('option',{attrs:{"value":"KP"}},[_vm._v("Korea North")]),_vm._v(" "),_c('option',{attrs:{"value":"KR"}},[_vm._v("Korea South")]),_vm._v(" "),_c('option',{attrs:{"value":"KW"}},[_vm._v("Kuwait")]),_vm._v(" "),_c('option',{attrs:{"value":"KG"}},[_vm._v("Kyrgyzstan")]),_vm._v(" "),_c('option',{attrs:{"value":"LA"}},[_vm._v("Laos")]),_vm._v(" "),_c('option',{attrs:{"value":"LV"}},[_vm._v("Latvia")]),_vm._v(" "),_c('option',{attrs:{"value":"LB"}},[_vm._v("Lebanon")]),_vm._v(" "),_c('option',{attrs:{"value":"LS"}},[_vm._v("Lesotho")]),_vm._v(" "),_c('option',{attrs:{"value":"LR"}},[_vm._v("Liberia")]),_vm._v(" "),_c('option',{attrs:{"value":"LY"}},[_vm._v("Libya")]),_vm._v(" "),_c('option',{attrs:{"value":"LI"}},[_vm._v("Liechtenstein")]),_vm._v(" "),_c('option',{attrs:{"value":"LT"}},[_vm._v("Lithuania")]),_vm._v(" "),_c('option',{attrs:{"value":"LU"}},[_vm._v("Luxembourg")]),_vm._v(" "),_c('option',{attrs:{"value":"MO"}},[_vm._v("Macao")]),_vm._v(" "),_c('option',{attrs:{"value":"MK"}},[_vm._v("Macedonia")]),_vm._v(" "),_c('option',{attrs:{"value":"MG"}},[_vm._v("Madagascar")]),_vm._v(" "),_c('option',{attrs:{"value":"MW"}},[_vm._v("Malawi")]),_vm._v(" "),_c('option',{attrs:{"value":"MY"}},[_vm._v("Malaysia")]),_vm._v(" "),_c('option',{attrs:{"value":"MV"}},[_vm._v("Maldives")]),_vm._v(" "),_c('option',{attrs:{"value":"ML"}},[_vm._v("Mali")]),_vm._v(" "),_c('option',{attrs:{"value":"MT"}},[_vm._v("Malta")]),_vm._v(" "),_c('option',{attrs:{"value":"MH"}},[_vm._v("Marshall Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"MQ"}},[_vm._v("Martinique")]),_vm._v(" "),_c('option',{attrs:{"value":"MR"}},[_vm._v("Mauritania")]),_vm._v(" "),_c('option',{attrs:{"value":"YT"}},[_vm._v("Mayotte")]),_vm._v(" "),_c('option',{attrs:{"value":"MX"}},[_vm._v("Mexico")]),_vm._v(" "),_c('option',{attrs:{"value":"FM"}},[_vm._v("Micronesia")]),_vm._v(" "),_c('option',{attrs:{"value":"MD"}},[_vm._v("Moldova")]),_vm._v(" "),_c('option',{attrs:{"value":"MC"}},[_vm._v("Monaco")]),_vm._v(" "),_c('option',{attrs:{"value":"MN"}},[_vm._v("Mongolia")]),_vm._v(" "),_c('option',{attrs:{"value":"MS"}},[_vm._v("Montserrat")]),_vm._v(" "),_c('option',{attrs:{"value":"MA"}},[_vm._v("Morocco")]),_vm._v(" "),_c('option',{attrs:{"value":"MZ"}},[_vm._v("Mozambique")]),_vm._v(" "),_c('option',{attrs:{"value":"MN"}},[_vm._v("Myanmar")]),_vm._v(" "),_c('option',{attrs:{"value":"NA"}},[_vm._v("Namibia")]),_vm._v(" "),_c('option',{attrs:{"value":"NR"}},[_vm._v("Nauru")]),_vm._v(" "),_c('option',{attrs:{"value":"NP"}},[_vm._v("Nepal")]),_vm._v(" "),_c('option',{attrs:{"value":"NL"}},[_vm._v("Netherlands")]),_vm._v(" "),_c('option',{attrs:{"value":"NC"}},[_vm._v("New Caledonia")]),_vm._v(" "),_c('option',{attrs:{"value":"NZ"}},[_vm._v("New Zealand")]),_vm._v(" "),_c('option',{attrs:{"value":"NI"}},[_vm._v("Nicaragua")]),_vm._v(" "),_c('option',{attrs:{"value":"NE"}},[_vm._v("Niger")]),_vm._v(" "),_c('option',{attrs:{"value":"NG"}},[_vm._v("Nigeria")]),_vm._v(" "),_c('option',{attrs:{"value":"NU"}},[_vm._v("Niue")]),_vm._v(" "),_c('option',{attrs:{"value":"NF"}},[_vm._v("Norfolk Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"NP"}},[_vm._v("Northern Marianas")]),_vm._v(" "),_c('option',{attrs:{"value":"NO"}},[_vm._v("Norway")]),_vm._v(" "),_c('option',{attrs:{"value":"OM"}},[_vm._v("Oman")]),_vm._v(" "),_c('option',{attrs:{"value":"PW"}},[_vm._v("Palau")]),_vm._v(" "),_c('option',{attrs:{"value":"PA"}},[_vm._v("Panama")]),_vm._v(" "),_c('option',{attrs:{"value":"PG"}},[_vm._v("Papua New Guinea")]),_vm._v(" "),_c('option',{attrs:{"value":"PY"}},[_vm._v("Paraguay")]),_vm._v(" "),_c('option',{attrs:{"value":"PE"}},[_vm._v("Peru")]),_vm._v(" "),_c('option',{attrs:{"value":"PH"}},[_vm._v("Philippines")]),_vm._v(" "),_c('option',{attrs:{"value":"PL"}},[_vm._v("Poland")]),_vm._v(" "),_c('option',{attrs:{"value":"PT"}},[_vm._v("Portugal")]),_vm._v(" "),_c('option',{attrs:{"value":"PR"}},[_vm._v("Puerto Rico")]),_vm._v(" "),_c('option',{attrs:{"value":"QA"}},[_vm._v("Qatar")]),_vm._v(" "),_c('option',{attrs:{"value":"RE"}},[_vm._v("Reunion")]),_vm._v(" "),_c('option',{attrs:{"value":"RO"}},[_vm._v("Romania")]),_vm._v(" "),_c('option',{attrs:{"value":"RW"}},[_vm._v("Rwanda")]),_vm._v(" "),_c('option',{attrs:{"value":"SM"}},[_vm._v("San Marino")]),_vm._v(" "),_c('option',{attrs:{"value":"ST"}},[_vm._v("Sao Tome & Principe")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("Saudi Arabia")]),_vm._v(" "),_c('option',{attrs:{"value":"SN"}},[_vm._v("Senegal")]),_vm._v(" "),_c('option',{attrs:{"value":"CS"}},[_vm._v("Serbia")]),_vm._v(" "),_c('option',{attrs:{"value":"SC"}},[_vm._v("Seychelles")]),_vm._v(" "),_c('option',{attrs:{"value":"SL"}},[_vm._v("Sierra Leone")]),_vm._v(" "),_c('option',{attrs:{"value":"SG"}},[_vm._v("Singapore")]),_vm._v(" "),_c('option',{attrs:{"value":"SK"}},[_vm._v("Slovak Republic")]),_vm._v(" "),_c('option',{attrs:{"value":"SI"}},[_vm._v("Slovenia")]),_vm._v(" "),_c('option',{attrs:{"value":"SB"}},[_vm._v("Solomon Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"SO"}},[_vm._v("Somalia")]),_vm._v(" "),_c('option',{attrs:{"value":"ZA"}},[_vm._v("South Africa")]),_vm._v(" "),_c('option',{attrs:{"value":"ES"}},[_vm._v("Spain")]),_vm._v(" "),_c('option',{attrs:{"value":"LK"}},[_vm._v("Sri Lanka")]),_vm._v(" "),_c('option',{attrs:{"value":"SH"}},[_vm._v("St. Helena")]),_vm._v(" "),_c('option',{attrs:{"value":"KN"}},[_vm._v("St. Kitts")]),_vm._v(" "),_c('option',{attrs:{"value":"SC"}},[_vm._v("St. Lucia")]),_vm._v(" "),_c('option',{attrs:{"value":"SD"}},[_vm._v("Sudan")]),_vm._v(" "),_c('option',{attrs:{"value":"SR"}},[_vm._v("Suriname")]),_vm._v(" "),_c('option',{attrs:{"value":"SZ"}},[_vm._v("Swaziland")]),_vm._v(" "),_c('option',{attrs:{"value":"SE"}},[_vm._v("Sweden")]),_vm._v(" "),_c('option',{attrs:{"value":"CH"}},[_vm._v("Switzerland")]),_vm._v(" "),_c('option',{attrs:{"value":"SI"}},[_vm._v("Syria")]),_vm._v(" "),_c('option',{attrs:{"value":"TW"}},[_vm._v("Taiwan")]),_vm._v(" "),_c('option',{attrs:{"value":"TJ"}},[_vm._v("Tajikstan")]),_vm._v(" "),_c('option',{attrs:{"value":"TH"}},[_vm._v("Thailand")]),_vm._v(" "),_c('option',{attrs:{"value":"TG"}},[_vm._v("Togo")]),_vm._v(" "),_c('option',{attrs:{"value":"TO"}},[_vm._v("Tonga")]),_vm._v(" "),_c('option',{attrs:{"value":"TT"}},[_vm._v("Trinidad & Tobago")]),_vm._v(" "),_c('option',{attrs:{"value":"TN"}},[_vm._v("Tunisia")]),_vm._v(" "),_c('option',{attrs:{"value":"TR"}},[_vm._v("Turkey")]),_vm._v(" "),_c('option',{attrs:{"value":"TM"}},[_vm._v("Turkmenistan")]),_vm._v(" "),_c('option',{attrs:{"value":"TM"}},[_vm._v("Turkmenistan")]),_vm._v(" "),_c('option',{attrs:{"value":"TC"}},[_vm._v("Turks & Caicos Islands")]),_vm._v(" "),_c('option',{attrs:{"value":"TV"}},[_vm._v("Tuvalu")]),_vm._v(" "),_c('option',{attrs:{"value":"UG"}},[_vm._v("Uganda")]),_vm._v(" "),_c('option',{attrs:{"value":"GB"}},[_vm._v("UK")]),_vm._v(" "),_c('option',{attrs:{"value":"UA"}},[_vm._v("Ukraine")]),_vm._v(" "),_c('option',{attrs:{"value":"AE"}},[_vm._v("United Arab Emirates")]),_vm._v(" "),_c('option',{attrs:{"value":"UY"}},[_vm._v("Uruguay")]),_vm._v(" "),_c('option',{attrs:{"value":"UZ"}},[_vm._v("Uzbekistan")]),_vm._v(" "),_c('option',{attrs:{"value":"VU"}},[_vm._v("Vanuatu")]),_vm._v(" "),_c('option',{attrs:{"value":"VA"}},[_vm._v("Vatican City")]),_vm._v(" "),_c('option',{attrs:{"value":"VE"}},[_vm._v("Venezuela")]),_vm._v(" "),_c('option',{attrs:{"value":"VN"}},[_vm._v("Vietnam")]),_vm._v(" "),_c('option',{attrs:{"value":"VG"}},[_vm._v("Virgin Islands - British")]),_vm._v(" "),_c('option',{attrs:{"value":"VI"}},[_vm._v("Virgin Islands - US")]),_vm._v(" "),_c('option',{attrs:{"value":"WF"}},[_vm._v("Wallis & Futuna")]),_vm._v(" "),_c('option',{attrs:{"value":"YE"}},[_vm._v("Yemen (North)")]),_vm._v(" "),_c('option',{attrs:{"value":"YE"}},[_vm._v("Yemen (South)")]),_vm._v(" "),_c('option',{attrs:{"value":"ZM"}},[_vm._v("Zambia")]),_vm._v(" "),_c('option',{attrs:{"value":"ZW"}},[_vm._v("Zimbabwe")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.getBackgroundColor),attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"preloader",staticStyle:{"opacity":"1"}},[_c('svg',{staticStyle:{"opacity":"1","margin-left":"0px","margin-top":"0px"},attrs:{"version":"1.1","id":"sun","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"10px","height":"10px","viewBox":"0 0 10 10","enable-background":"new 0 0 10 10","xml:space":"preserve"}},[_c('g',[_c('path',{attrs:{"fill":"none","d":"M6.942,3.876c-0.4-0.692-1.146-1.123-1.946-1.123c-0.392,0-0.779,0.104-1.121,0.301c-1.072,0.619-1.44,1.994-0.821,3.067C3.454,6.815,4.2,7.245,5,7.245c0.392,0,0.779-0.104,1.121-0.301C6.64,6.644,7.013,6.159,7.167,5.581C7.321,5,7.243,4.396,6.942,3.876z M6.88,5.505C6.745,6.007,6.423,6.427,5.973,6.688C5.676,6.858,5.34,6.948,5,6.948c-0.695,0-1.343-0.373-1.69-0.975C2.774,5.043,3.093,3.849,4.024,3.312C4.32,3.14,4.656,3.05,4.996,3.05c0.695,0,1.342,0.374,1.69,0.975C6.946,4.476,7.015,5,6.88,5.505z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M8.759,2.828C8.718,2.757,8.626,2.732,8.556,2.774L7.345,3.473c-0.07,0.041-0.094,0.132-0.053,0.202C7.319,3.723,7.368,3.75,7.419,3.75c0.025,0,0.053-0.007,0.074-0.02l1.211-0.699C8.774,2.989,8.8,2.899,8.759,2.828z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M1.238,7.171c0.027,0.047,0.077,0.074,0.128,0.074c0.025,0,0.051-0.008,0.074-0.02l1.211-0.699c0.071-0.041,0.095-0.133,0.054-0.203S2.574,6.228,2.503,6.269l-1.21,0.699C1.221,7.009,1.197,7.101,1.238,7.171z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M6.396,2.726c0.052,0,0.102-0.026,0.13-0.075l0.349-0.605C6.915,1.976,6.89,1.885,6.819,1.844c-0.07-0.042-0.162-0.017-0.202,0.054L6.269,2.503C6.228,2.574,6.251,2.666,6.322,2.706C6.346,2.719,6.371,2.726,6.396,2.726z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M3.472,7.347L3.123,7.952c-0.041,0.07-0.017,0.162,0.054,0.203C3.2,8.169,3.226,8.175,3.25,8.175c0.052,0,0.102-0.027,0.129-0.074l0.349-0.605c0.041-0.07,0.017-0.16-0.054-0.203C3.603,7.251,3.513,7.276,3.472,7.347z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M3.601,2.726c0.025,0,0.051-0.007,0.074-0.02C3.746,2.666,3.77,2.574,3.729,2.503l-0.35-0.604C3.338,1.828,3.248,1.804,3.177,1.844C3.106,1.886,3.082,1.976,3.123,2.047l0.35,0.604C3.5,2.7,3.549,2.726,3.601,2.726z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M6.321,7.292c-0.07,0.043-0.094,0.133-0.054,0.203l0.351,0.605c0.026,0.047,0.076,0.074,0.127,0.074c0.025,0,0.051-0.006,0.074-0.02c0.072-0.041,0.096-0.133,0.055-0.203l-0.35-0.605C6.483,7.276,6.393,7.253,6.321,7.292z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M2.202,5.146c0.082,0,0.149-0.065,0.149-0.147S2.284,4.851,2.202,4.851H1.503c-0.082,0-0.148,0.066-0.148,0.148s0.066,0.147,0.148,0.147H2.202z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M8.493,4.851H7.794c-0.082,0-0.148,0.066-0.148,0.148s0.066,0.147,0.148,0.147l0,0h0.699c0.082,0,0.148-0.065,0.148-0.147S8.575,4.851,8.493,4.851L8.493,4.851z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M5.146,2.203V0.805c0-0.082-0.066-0.148-0.148-0.148c-0.082,0-0.148,0.066-0.148,0.148v1.398c0,0.082,0.066,0.149,0.148,0.149C5.08,2.352,5.146,2.285,5.146,2.203z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M4.85,7.796v1.396c0,0.082,0.066,0.15,0.148,0.15c0.082,0,0.148-0.068,0.148-0.15V7.796c0-0.082-0.066-0.148-0.148-0.148C4.917,7.647,4.85,7.714,4.85,7.796z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M2.651,3.473L1.44,2.774C1.369,2.732,1.279,2.757,1.238,2.828C1.197,2.899,1.221,2.989,1.292,3.031l1.21,0.699c0.023,0.013,0.049,0.02,0.074,0.02c0.051,0,0.101-0.026,0.129-0.075C2.747,3.604,2.722,3.514,2.651,3.473z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"none","d":"M8.704,6.968L7.493,6.269c-0.07-0.041-0.162-0.016-0.201,0.055c-0.041,0.07-0.018,0.162,0.053,0.203l1.211,0.699c0.023,0.012,0.049,0.02,0.074,0.02c0.051,0,0.102-0.027,0.129-0.074C8.8,7.101,8.776,7.009,8.704,6.968z"}})])]),_vm._v(" "),_c('svg',{attrs:{"version":"1.1","id":"cloud","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"10px","height":"10px","viewBox":"0 0 10 10","enable-background":"new 0 0 10 10","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"none","d":"M8.528,5.624H8.247c-0.085,0-0.156-0.068-0.156-0.154c0-0.694-0.563-1.257-1.257-1.257c-0.098,0-0.197,0.013-0.3,0.038C6.493,4.259,6.45,4.252,6.415,4.229C6.38,4.208,6.356,4.172,6.348,4.131C6.117,3.032,5.135,2.235,4.01,2.235c-1.252,0-2.297,0.979-2.379,2.23c-0.004,0.056-0.039,0.108-0.093,0.13C1.076,4.793,0.776,5.249,0.776,5.752c0,0.693,0.564,1.257,1.257,1.257h6.495c0.383,0,0.695-0.31,0.695-0.692S8.911,5.624,8.528,5.624z"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n        LOADING...\n      ")])]):[_c('header',[_c('search-city')],1),_vm._v(" "),_c('main',[_c('forecast')],1)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rain"},[_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"}),_vm._v(" "),_c('span',{staticClass:"drop"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchCity__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forecast__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__favoriteCountries__ = __webpack_require__(389);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    searchCity: __WEBPACK_IMPORTED_MODULE_2__searchCity__["a" /* default */],
    forecast: __WEBPACK_IMPORTED_MODULE_3__forecast__["a" /* default */],
    favorite: __WEBPACK_IMPORTED_MODULE_4__favoriteCountries__["a" /* default */]
  }
}));

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    selectedCountry: '',
    searchQuery: ''
  },
  mutations: {
    saveSelectedCountry: function saveSelectedCountry(state, payload) {
      state.selectedCountry = payload;
    },
    saveSearchQuery: function saveSearchQuery(state, payload) {
      state.searchQuery = payload;
    }
  },
  actions: {},
  getters: {
    getSelectedCountry: function getSelectedCountry(state) {
      return state.selectedCountry;
    },
    getSearchQuery: function getSearchQuery(state) {
      return state.searchQuery;
    }
  }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    publicKey: '08dfd1c2ed554573bd99d2026ae852cf',
    forecasts: [],
    averageTemperature: 0,
    loading: false,
    addedToFavorite: false,
    error: '',
    lat: '',
    lon: ''
  },
  mutations: {
    updateAnimationState: function updateAnimationState(state, payload) {
      state.addedToFavorite = payload;
    },
    saveForecasts: function saveForecasts(state, payload) {
      state.forecasts = payload;
    },
    saveTemperature: function saveTemperature(state, payload) {
      state.averageTemperature = payload;
    },
    updateLoadingState: function updateLoadingState(state, payload) {
      state.loading = payload;
    },
    setErrorMessage: function setErrorMessage(state, payload) {
      state.error = payload;
    },
    saveLongitude: function saveLongitude(state, payload) {
      state.lon = payload;
    },
    saveLatitude: function saveLatitude(state, payload) {
      state.lat = payload;
    }
  },
  actions: {
    getForecastsFromAPI: function getForecastsFromAPI(_ref) {
      var commit = _ref.commit,
          state = _ref.state,
          rootState = _ref.rootState;

      var resultTemperature = 0;
      commit('setErrorMessage', '');
      commit('updateLoadingState', true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.weatherbit.io/v2.0/forecast/daily?city=' + rootState.searchCity.searchQuery + ',' + rootState.searchCity.selectedCountry + '&key=' + state.publicKey).then(function (response) {
        commit('saveForecasts', response.data);
        for (var i = 0; i < response.data.data.length; i += 1) {
          resultTemperature += response.data.data[i].temp;
        }
        commit('saveTemperature', Math.ceil(resultTemperature / response.data.data.length));
        commit('updateLoadingState', false);
      }).catch(function () {
        commit('updateLoadingState', false);
        commit('setErrorMessage', 'This city does not exist 😆');
        // throw error;
      });
    },
    getForecastsFromAPIByLatAndLon: function getForecastsFromAPIByLatAndLon(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      var resultTemperature = 0;
      commit('setErrorMessage', '');
      commit('updateLoadingState', true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.weatherbit.io/v2.0/forecast/daily?lat=' + state.lat + '&lon=' + state.lon + '&key=' + state.publicKey).then(function (response) {
        commit('saveForecasts', response.data);
        for (var i = 0; i < response.data.data.length; i += 1) {
          resultTemperature += response.data.data[i].temp;
        }
        commit('saveTemperature', Math.ceil(resultTemperature / response.data.data.length));
        commit('updateLoadingState', false);
        commit('saveSelectedCountry', response.data.country_code);
        commit('saveSearchQuery', response.data.city_name);
      }).catch(function () {
        commit('updateLoadingState', false);
        commit('setErrorMessage', 'This city does not exist 😆');
        // throw error;
      });
    }
  },
  getters: {
    getForecasts: function getForecasts(state) {
      return state.forecasts;
    },
    getAverageTemperature: function getAverageTemperature(state) {
      return state.averageTemperature;
    },
    getLoadingState: function getLoadingState(state) {
      return state.loading;
    },
    getErrorMessage: function getErrorMessage(state) {
      return state.error;
    },
    getAnimationState: function getAnimationState(state) {
      return state.addedToFavorite;
    }
  }
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    favoriteCities: []
  },
  mutations: {
    addToFavoriteList: function addToFavoriteList(state, payload) {
      state.favoriteCities.push(payload);
      localStorage.setItem('favoriteCities', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.favoriteCities));
    },
    deleteFromFavoriteList: function deleteFromFavoriteList(state, payload) {
      state.favoriteCities.splice(payload, 1);
      localStorage.setItem('favoriteCities', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.favoriteCities));
    },
    loadCitiesFromLocalStorage: function loadCitiesFromLocalStorage(state) {
      state.favoriteCities = JSON.parse(localStorage.getItem('favoriteCities')) || [];
    }
  },
  actions: {},
  getters: {
    getFavoriteCities: function getFavoriteCities(state) {
      return state.favoriteCities;
    }
  }
});

/***/ })

},[141]);


// WEBPACK FOOTER //
// static/js/app.9f6a76abf82f4fe17952.js